const inseminationMutations = {
	GET_COUNTER_PENDINGS: 'GET_COUNTER_PENDINGS' 

};

export default Object.freeze({
	...inseminationMutations,
});
